import React from 'react';
import KpiContainer from 'containers/kpi/KpiContainer';
import KpiAddContainer from 'containers/kpi/KpiAddContainer';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import { Route, Redirect, Switch } from 'react-router-dom';
import { pageUrl } from 'lib/mapper';

function User() {
  return (
    <AppTemplate
      title={'Kpi'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <Switch>
        <Redirect exact path={pageUrl.kpi.index} to={pageUrl.kpi.list} />
        <Route path={pageUrl.kpi.list} component={KpiContainer} />
        <Route path={pageUrl.kpi.add} component={KpiAddContainer} />
        <Route component={() => <Redirect to={pageUrl.error.notFound} />} />
      </Switch>
    </AppTemplate>
  );
}

export default User;
